import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import envelopeIcon from '@static/images/icons/envelope-icon.svg';
import listIcon from '@static/images/icons/list-icon.svg';
import linkedInIcon from '@images/icons/linkedin.svg';
import { ContactBarProps } from './ContactBarProps';

import * as styles from './ContactBar.module.scss';

export const ContactBar: React.FC<ContactBarProps> = ({
	email,
	linkedIn,
	className,
}) => {
	return (
		<div className={className}>
			<div className={styles.contactBar}>
				<a href={linkedIn} target="_blank">
					<button
						className={classNames(
							styles.btn,
							'd-flex align-items-center bttn bttn-orange-border'
						)}
					>
						<img src={linkedInIcon} height="16px" />
						<p className="uppercase">LinkedIn</p>
					</button>
				</a>
				<a href={'mailto:' + email}>
					<button
						className={classNames(
							styles.btn,
							'd-flex align-items-center bttn bttn-orange-border'
						)}
					>
						<img src={envelopeIcon} height="16px" />
						<p>{email}</p>
					</button>
				</a>
				<Link to="/contact/" className="z-9">
					<button
						className={classNames(
							styles.btn,
							'd-none d-md-flex align-items-center bttn bttn-orange-border'
						)}
					>
						<img src={listIcon} height="16px" />
						<p className="uppercase">Contact</p>
					</button>
				</Link>
			</div>
		</div>
	);
};
